export default __webpack_public_path__ + "static/media/ptimg.3b7e4033.svg";